import React from "react";
import Switch from "react-switch";

interface ToggleSwitchProps {
  leftLabel: string;
  rightLabel: string;
  isChecked: boolean;
  isLoading?: boolean;
  onChange: (checked: boolean) => void | Promise<void>;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  leftLabel,
  rightLabel,
  isChecked,
  isLoading = false,
  onChange,
}) => {
  const handleIconBaseClasses =
    "flex h-full w-full items-center justify-center text-white";
  const loadingHandleIcon = (
    <div className={handleIconBaseClasses}>
      <span className="block h-2.5 w-2.5 animate-spin rounded-full border-[1.5px] border-white/50 border-t-white" />
    </div>
  );

  return (
    <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
      <p className="text-right whitespace-nowrap">{leftLabel}</p>
      <div
        className={`rounded-full p-1 transition-colors duration-200 ease-out ${
          isChecked ? "hover:bg-primary/10" : "hover:bg-[#E5E7EB]"
        }`}
      >
        <Switch
          uncheckedIcon={false}
          checkedIcon={false}
          height={28}
          width={54}
          handleDiameter={22}
          borderRadius={999}
          onColor="#00A09B"
          offColor="#A0A0A0"
          onHandleColor="#FFFFFF"
          offHandleColor="#FFFFFF"
          activeBoxShadow="0 0 0 2px rgba(0, 160, 155, 0.16)"
          boxShadow="0 2px 6px rgba(0, 0, 0, 0.18)"
          onChange={onChange}
          checked={isChecked}
        />
      </div>
      <p className="text-left whitespace-nowrap">{rightLabel}</p>
    </div>
  );
};

export default ToggleSwitch;
